/*
  El sello "18K" sigue a la variante elegida.

  El HTML (snippets/gold-stamp.liquid) ya sale oculto si la variante inicial es
  de plata. Aqui se actualiza cuando el cliente cambia de variante:
    - Ficha de producto: se escucha "change" en <variant-selects>, igual que hace
      assets/variant-image-sync.js, asi sirve para pildoras, muestras y
      desplegables y no depende de la cadena de eventos de Dawn.
    - Tarjetas de coleccion: card-variants.js llama a GoldStamp.apply().
  Una variante no es de oro si alguno de sus valores nombra plata o acero.
*/
(function () {
  var NOT_GOLD = /s\u00f8lv|silver|sterling|rustfri|st\u00e5l|steel|925/i;

  function isGoldVariant(values) {
    for (var i = 0; i < values.length; i++) {
      if (NOT_GOLD.test(String(values[i] == null ? '' : values[i]))) return false;
    }
    return true;
  }

  function apply(scope, values) {
    if (!scope) return;
    var gold = isGoldVariant(values);
    Array.prototype.forEach.call(scope.querySelectorAll('.gold-stamp'), function (stamp) {
      stamp.hidden = !gold;
    });
  }

  function selectedValues(root) {
    var values = [];
    Array.prototype.forEach.call(root.querySelectorAll('.product-form__input'), function (group) {
      var radio = group.querySelector('input[type="radio"]:checked');
      if (radio) return values.push(radio.value);
      var select = group.querySelector('select');
      if (select) values.push(select.value);
    });
    return values;
  }

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var root = target.closest('variant-selects');
    if (!root) return;
    var values = selectedValues(root);
    if (!values.length) return;
    // La galeria vive en el mismo bloque de producto (pagina o ventana rapida).
    var scope = root.closest('product-info') || root.closest('.shopify-section') || document;
    apply(scope, values);
  });

  window.GoldStamp = { isGoldVariant: isGoldVariant, apply: apply };
})();
